export function isMobile(mq: any) {
	return mq === "md" || mq === "sm" || mq === "xs"
}
